<div class="statements-parents">
  <table class="page-table">

    <tr>
      <td colspan="3">
        <kendo-grid class="statements-parents-table"
                    [kendoGridBinding]="parents"
                    [loading]="loading"
                    [pageSize]="pageSize"
                    [resizable]="true"
                    [pageable]="{
                            buttonCount: buttonCount,
                            info: info,
                            type: type,
                            pageSizes: pageSizes,
                            previousNext: previousNext
                            }"
                    [sortable]="true"
                    [sort]="sort"
                    [scrollable]="true"
                    (selectedKeysChange)="change($event)"
                    (pageChange)="pageChange($event)"
                    [selectable]="{
                      mode: 'multiple',
                      checkboxOnly: false}"
                    filterable="menu"
                    (selectionChange)="allRowsSelected($event)"
                    [rowSelected]="isRowSelected"
                    [skip]="skip"
                    [kendoGridSelectBy]="selectionKey"
                    [selectedKeys]="selectedKeys"
                    [reorderable]="true"
                    [filter]="">
          <ng-template kendoGridToolbarTemplate>
            <input type="checkbox" class="master-select " [(ngModel)]="masterSelect" (click)="masterClicked()"
                   kendoCheckBox/>
            <label class="k-checkbox-label" style="padding-top: 10px;">All Records</label>
            <kendo-grid-column-chooser style="margin-left: auto;"></kendo-grid-column-chooser>
          </ng-template>
          <kendo-grid-checkbox-column [width]="55" [showSelectAll]="true" [reorderable]="false"
                                      [columnMenu]="false">
            <ng-template kendoGridHeaderTemplate>
              <input type="checkbox" class="k-checkbox" id="selectAllCheckboxId" kendoGridSelectAllCheckbox
                     [checked]="selectAllChecked"
                     (selectAllChange)="allRowsSelected($event)">
              <label class="k-checkbox-label" for="selectAllCheckboxId">Page</label>
            </ng-template>
          </kendo-grid-checkbox-column>

          <kendo-grid-column field="id" title="Parent Customer" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="siteNumber" title="Parent Store" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="siteName" title="Description" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="openAmt" format="{0:n2}" title="Open Amount " [width]="150">
          </kendo-grid-column>
        </kendo-grid>
      </td>
    </tr>
    <tr>
      <td>

        <table class="b-button-bar">
          <tr>
            <td>
              <app-mcl-button text="< Back" primary="true" (click)="backClicked()" [disabled]="false">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="Next To Store Selection >" primary="true" (click)="nextClicked()" [disabled]="disabled">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="Download" primary="true" [svgIcon]="downloadIcon" [disabled]="true">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="View Statement" primary="true" [disabled]="true">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="View Invoice" primary="true" [disabled]="true">
              </app-mcl-button>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <div kendoDialogContainer></div>
</div>
